import { render, staticRenderFns } from "./DeleteExpenseLabelModal.vue?vue&type=template&id=3c6d5f09&scoped=true&class=fill-height&"
import script from "./DeleteExpenseLabelModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteExpenseLabelModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteExpenseLabelModal.vue?vue&type=style&index=0&id=3c6d5f09&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d5f09",
  null
  
)

export default component.exports